import { Component, OnInit } from '@angular/core';
import { CommonService } from '../../service/common.service';
import { Router } from '@angular/router';
import { Azienda } from '../../models/azienda';
import { Commessa } from '../../models/commessa';
import { Tipopagamento } from '../../models/tipopagamento';
import { Metodopagamento } from '../../models/metodopagamento';
import { Pagamento } from '../../models/pagamento';

import { HttpClient, HttpHeaders } from "@angular/common/http";
import { environment } from '../../../environments/environment';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { configurazione } from '../../../configurazioni/configurazione';
import { MatTableDataSource } from '@angular/material/table';

@Component({
  selector: 'app-addpagamento',
  templateUrl: './addpagamento.component.html',
  styleUrls: ['./addpagamento.component.css']
})
export class AddpagamentoComponent implements OnInit {
  pagamento: Pagamento=new Pagamento();
  tipopagamento:Tipopagamento;
  metodopagamento:Metodopagamento;
  commessa:Commessa;
  azienda:Azienda;
  selectedValueTipopagamento:number=0;
  selectedValueMetodopagamento:number=0;
  tipipagamento: Tipopagamento[];
  metodipagamento: Metodopagamento[];
  importodovutocommessa:number=0;
  importopagatocommessa:number=0;
  ivadovutacommessa:number=0;
  ivapagatacommessa:number=0;
  saldocommessa:number=0;
  registerForm: FormGroup;
  submitted = false;


  docfiscali = ['', 'Fattura', 'Nota Credito'];


  constructor(private httpClient: HttpClient, private commonService: CommonService,
    private router: Router, private formBuilder: FormBuilder) {


    }

  ngOnInit(): void {


    if (this.registerForm===undefined){
    this.registerForm = this.formBuilder.group({
        selectedValueAzienda:['', Validators.required],
        selectedValueCommessa:['', Validators.required],
        selectedValueTipopagamento:['', Validators.required],
        selectedValueMetodopagamento:['', Validators.required],
        Id:[0],
        Datapagamento:['', Validators.required],
        Importo:[0, Validators.required],
        Note:[''],
        selectedValueDocfiscale:[''],
        });
    }



    this.commonService.getAllTipipagamento().subscribe((res1) => {
      this.tipipagamento = res1;

      this.commonService.getAllMetodipagamento().subscribe((res2) => {
          this.metodipagamento = res2;

          if (this.commonService.selectedAzienda!=undefined){
            this.azienda=this.commonService.selectedAzienda;
            this.commonService.selectedAzienda=undefined;
          }else{
            this.azienda=new Azienda();
          }

          if (this.commonService.selectedCommessa!=undefined){
            this.commessa=this.commonService.selectedCommessa;
            this.commonService.selectedCommessa=undefined;
          }else{
            this.commessa=new Commessa();
          }

          if (this.commonService.selectedPagamento!=undefined){
                this.pagamento=this.commonService.selectedPagamento;
                this.commonService.selectedPagamento=undefined;
          }else{
                this.pagamento=new Pagamento();
          }



          this.registerForm.patchValue({
                  selectedValueAzienda:this.azienda.Nome,
                  selectedValueCommessa:this.commessa.Codice,
                  selectedValueTipopagamento:this.pagamento.Tipopagamento.Id,
                  selectedValueMetodopagamento:this.pagamento.Metodopagamento.Id,
                  Id:this.pagamento.Id,
                  Importo:this.pagamento.Importo,
                  Note:this.pagamento.Note,
                  Docfiscale: this.pagamento.Docfiscale
          });
          this.aggiornaimporticommessa();
      });
    });

  }

aggiornaimporticommessa() {
  if (this.commessa!=undefined){
    this.commonService.getImportotaleByCommmessaid(this.commessa.Codice).subscribe(res =>  {
      this.importodovutocommessa=res;
      this.ivadovutacommessa=Number((res*configurazione.iva).toFixed(2));
      this.commonService.getAllPagamentiByCommessaid(this.commessa.Codice).subscribe((res1) => {
        let pagamenticommessa:Pagamento[]=res1;
        let temp=0;
        pagamenticommessa.forEach(p => {
          temp=temp+p.Importo;
        });
        this.importopagatocommessa=temp;
        this.ivapagatacommessa=Number((temp*configurazione.iva).toFixed(2));
//        this.saldocommessa=Number((this.importodovutocommessa+this.ivadovutacommessa-this.importopagatocommessa-this.ivapagatacommessa).toFixed(2));
        this.saldocommessa=Number((this.importodovutocommessa-this.importopagatocommessa).toFixed(2));

      });
    });
  }
 }
aggiornaForm(){

}

get f() { return this.registerForm.controls; }

save() {

        this.submitted = true;

        // stop here if form is invalid
        if (this.registerForm.invalid) {
            alert("Errore: verifica i campi indicati con *");
            return;
        }else if (this.registerForm.value.Importo===0){
            alert("L'importo non può essere nullo");
            return;
        }else{

            this.pagamento.Id=0;
            this.pagamento.Importo=this.registerForm.value.Importo;
            this.pagamento.Note='';
            this.pagamento.Azienda=this.azienda;
            this.pagamento.Commessa=this.commessa;

            this.tipipagamento.forEach(t => {
              if (t.Id===this.registerForm.value.selectedValueTipopagamento){
                this.tipopagamento=t;
              }
            });
            this.pagamento.Tipopagamento=this.tipopagamento;


            this.metodipagamento.forEach(m => {
              if (m.Id===this.registerForm.value.selectedValueMetodopagamento){
                this.metodopagamento=m;
              }
            });
            this.pagamento.Metodopagamento=this.metodopagamento;

            this.pagamento.Datapagamento=this.registerForm.value.Datapagamento;

            this.pagamento.Note=this.registerForm.value.Note;
      //      let s=this.dateToString(this.registerForm.value.Datapagamento);
      //      if (s!=''){
      //        this.registerForm.value.Datapagamento=s;
      //      }

            this.pagamento.Docfiscale=this.registerForm.value.selectedValueDocfiscale;

            this.commonService.savePagamento(this.pagamento).subscribe(data => {
              let rc=Number(data); //ritorna l'id dell'utente se è stato creato con successo
              //console.log("--->SaveUser"+this.rc.toString());
              if (rc===0){
                alert("Pagamento salvato con successo");
              }else if (rc===-1){
                alert("Errore creazione pagamento");
              }
              this.router.navigate(['pagamenti']);
            });

        }
    }


    manageChangeImporto(value:any){
        if (isNaN(value.target.value)){
          value.target.value=this.pagamento.Importo;
        }else{
          this.pagamento.Importo=Number(value.target.value);
        }
    }


  cancel(){
    this.commonService.selectedPagamento=null;
    this.router.navigate(['pagamenti']);
  }


  dateToString(d: Date): string {
    let s:string='9999-12-31';
    if(d!=undefined){
      if (d instanceof Date){
//        console.log("--->"+d);
      }else{
        return '';
      }
      let month:string = (d.getMonth()+1).toString();
      if ((d.getMonth()+1)<10){
        month='0'+month;
      }

      let year = d.getFullYear().toString();
      let day = d.getDate().toString();
      if (d.getDate().toString().length == 1){
        day='0'+day;
      }
      s=year+'-'+month+'-'+day;
    }
    return s;
  }


  myFilter(d: Date): boolean {
  //		const selectinableday = d.getDay();
  //console.log("---->"+d);
    if(d!=undefined){
      const selectinablemonth = d.getMonth();
      const selectinableyear = d.getFullYear();
      const selectinableday = d.getDate();
      const todaysDateObject = new Date();
      const actualday = todaysDateObject.getDate();
      const actualmonth = todaysDateObject.getMonth();
      const actualyear = todaysDateObject.getFullYear();
      if (actualyear - 11> selectinableyear){
        return true;
      }else{
        return false;
      }
    }
    return false;
  }

  isHidden(){
    return 'none';
  }

  getConfigurazione(){
    return configurazione;
  }

}
